import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { SocialLink } from "./components/SocialLink";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
export var SocialLinks = /*#__PURE__*/memo(function (_ref) {
  var socialsLinks = _ref.socialsLinks;
  return /*#__PURE__*/React.createElement("ul", {
    className: cn('social-links')
  }, socialsLinks.map(function (_ref2) {
    var name = _ref2.name,
      srcImage = _ref2.srcImage,
      url = _ref2.url;
    return /*#__PURE__*/React.createElement(SocialLink, {
      key: name,
      name: name,
      srcImage: srcImage,
      url: url
    });
  }));
});